export default "__VITE_ASSET__UmnqOGv1__"